// TODO: re-implement when required
import { fork, all } from 'redux-saga/effects'
import settings from './entities/settings/settings.saga'
import members from './entities/member/member.saga'
import organisations from './entities/organisations/organisations.saga'

const sagas = [...settings, ...members, ...organisations]

function* rootSaga() {
  yield all(sagas.map(fork))
}

export default rootSaga
